import PropTypes from "prop-types";
import PageIntro from "../../../components/PageIntro/component";
import { getRegionalPath } from "../../../utils/path/library";
import { insertPolopolyProps } from "../../../utils/pageIntro/library";
import { OnElectionHide } from "../../../components/Election";

/**
 * This function determines whether the page intro needs to be displayed
 *
 * @param {string} path the current app path
 * @param {string} baseSection the current app base section
 * @param {object} rightrail the page rightrail info
 * @returns {jsx} The JSX for PageIntro
 */
function getRegionIntro(path, baseSection, rightrail) {
    const regionObj = getRegionalPath(path);

    // Whenever elections widget is showing, region intro should not show, do not
    // remove unless there is no future use of the elections widget
    if (regionObj) {
        return (
            <OnElectionHide path={path}>
                {getPageIntro(regionObj, baseSection, rightrail)}
            </OnElectionHide>
        );
    }
    return null;
}

/**
 * Returns the PageIntro for Regions that have their own banners and sub-navigations
 *
 * @param {string} regionObj the selected region info
 * @param {string} baseSection the current app base section
 * @param {object} rightrail the page rightrail info
 * @returns {jsx} The JSX for PageIntro
 */
function getPageIntro(regionObj, baseSection, rightrail) {
    const currentRegionProps = insertPolopolyProps(
        {
            navigation: regionObj.pageIntro
                ? regionObj.pageIntro.navigation
                : [],
            showName: regionObj.title,
            baseSection: baseSection,
            showImage: false,
        },
        rightrail
    );

    return <PageIntro {...currentRegionProps} />;
}

const RegionIntro = ({ path, baseSection, rightrail }) => {
    return getRegionIntro(path, baseSection, rightrail);
};

RegionIntro.propTypes = {
    path: PropTypes.string,
    baseSection: PropTypes.string,
    rightrail: PropTypes.object,
};

export default RegionIntro;
